<template>
    <v-row no-gutters class="d-block">
        <v-col cols="12" sm="12" md="12" lg="12" xl="12">
            <v-card>
                <v-card-title class="pb-2">
                    <v-row dense align="center">
                        <v-col cols="12" sm="6" md="3" lg="2">
                            <v-btn color="success" small v-if="permisos[2]" outlined @click="cursosNuevo()">
                                <v-icon>add</v-icon>
                                Nuevo
                            </v-btn>
                            <v-btn color="info" small outlined class="ml-1" @click="cursosGet()">
                                <v-icon>refresh</v-icon>
                                Refrescar
                            </v-btn>
                        </v-col>

                        <v-col cols="6" sm="3" md="2" lg="2">
                            <v-select
                                dense hide-details
                                label="Año"
                                v-model="filtros.anyo"
                                :items="catAnyos"
                                item-text="anyo"
                                item-value="cat_anyo_id"
                                @input="cursosBuscar()"
                            />
                        </v-col>

                        <v-col cols="6" sm="3" md="3" lg="2">
                            <v-select
                                dense hide-details
                                label="Unidad operativa"
                                v-model="filtros.unidad_operativa_id"
                                :items="unidadesOperativas"
                                item-text="unidad_operativa"
                                item-value="unidad_operativa_id"
                                @input="cursosBuscar()"
                            />
                        </v-col>

                        <!-- Buscador: primero se elige por qué campo, luego se escribe. -->
                        <v-col cols="12" sm="4" md="2" lg="2">
                            <v-select
                                dense hide-details outlined
                                label="Buscar por"
                                v-model="campo"
                                :items="camposBusqueda"
                                item-text="texto"
                                item-value="valor"
                                prepend-inner-icon="filter_list"
                                @change="cambiarCampo"
                            />
                        </v-col>

                        <v-col cols="12" sm="8" md="12" lg="4">
                            <!-- Nombre del participante: sugerencias de personas mientras se escribe -->
                            <v-autocomplete
                                v-if="campo === 'nombre'"
                                ref="buscador"
                                dense hide-details outlined clearable
                                :label="etiquetaCampo"
                                :placeholder="placeholderCampo"
                                prepend-inner-icon="search"
                                :items="sugerencias"
                                :loading="cargandoSugerencias"
                                :search-input.sync="search"
                                item-text="etiqueta"
                                item-value="persona_id"
                                return-object
                                no-filter
                                hide-no-data
                                :menu-props="{maxHeight: 320}"
                                v-model="participante"
                                @change="seleccionarParticipante"
                                @keyup.enter="cursosBuscar()"
                                @click:clear="limpiarTexto"
                            >
                                <template v-slot:item="{ item }">
                                    <v-list-item-avatar color="primary" size="32" class="white--text text-subtitle-2">
                                        {{ item.iniciales }}
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                        <v-list-item-title>{{ item.nombre }} {{ item.apellido }}</v-list-item-title>
                                        <v-list-item-subtitle>Identidad {{ item.numero_identidad }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </template>
                            </v-autocomplete>

                            <!-- Identidad, registro, curso o todos: texto libre -->
                            <v-text-field
                                v-else
                                ref="buscador"
                                dense hide-details outlined clearable
                                :label="etiquetaCampo"
                                :placeholder="placeholderCampo"
                                :inputmode="campo === 'identidad' || campo === 'registro' ? 'numeric' : 'text'"
                                prepend-inner-icon="search"
                                v-model="search"
                                :loading="loading"
                                @keyup.enter="cursosBuscar()"
                                @click:clear="limpiarTexto"
                            />
                        </v-col>
                    </v-row>

                    <!-- Filtros activos -->
                    <v-row dense v-if="chips.length" class="mt-1">
                        <v-col cols="12" class="d-flex flex-wrap align-center">
                            <span class="text-caption grey--text text--darken-1 mr-2">Filtrando por:</span>
                            <v-chip
                                v-for="chip in chips" :key="chip.clave"
                                small close outlined color="primary" class="mr-1 mb-1"
                                @click:close="quitarChip(chip.clave)">
                                <v-icon left small>{{ chip.icono }}</v-icon>
                                <strong class="mr-1">{{ chip.titulo }}:</strong> {{ chip.valor }}
                            </v-chip>
                            <v-btn text x-small color="secondary" class="mb-1" @click="limpiarTodo">
                                <v-icon small left>backspace</v-icon> Limpiar todo
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-title>

                <v-card-text>
                    <v-data-table
                        dense
                        class="elevation-3 tabla-cursos"
                        :headers="tableHeaders"
                        :items="cursos"
                        :loading="loading"
                        item-key="curso_id"
                        fixed-header
                        height="62vh"
                        :hide-default-footer="true"
                        disable-pagination
                    >
                        <template v-slot:item="{ item }">
                            <tr>
                                <td class="text-left text-no-wrap" v-html="resaltar(item.numero_identidad, 'identidad')"></td>
                                <td class="text-left" v-html="resaltar(item.nombres_apellidos, 'nombre')"></td>
                                <td class="text-left" v-html="resaltar(item.registro, 'registro')"></td>
                                <td class="text-left" v-html="resaltar(item.curso, 'curso')"></td>
                                <td class="text-left">{{ item.fecha_inicio | fechaESP }} al {{ item.fecha_finalizacion | fechaESP }}</td>
                                <td class="text-left">{{ item.tutor }}</td>
                                <td class="text-left">{{ item.importacion_numero }}</td>
                                <td class="text-center">
                                    <v-btn color="info" small outlined @click="cursoEdit(item)" title="Editar" v-if="permisos[3]">
                                        <v-icon>edit</v-icon>
                                    </v-btn>
                                </td>
                            </tr>
                        </template>
                        <template v-slot:no-data>
                            <v-alert dense type="info" outlined class="text-center mt-3" v-if="hayBusqueda">
                                No se encontraron cursos {{ descripcionBusqueda }}.
                            </v-alert>
                            <v-alert dense type="warning" outlined class="text-center mt-3" v-else>
                                No existen registros.
                            </v-alert>
                        </template>
                    </v-data-table>
                    <Pagination :pagination="pagination" @setCambiarPagina="setCambiarPagina" v-if="pagination.total"/>
                </v-card-text>
            </v-card>
        </v-col>

    </v-row>

</template>

<script>
import Auth from "@/services/auth";
const Pagination = () => import("@/pages/Components/Pagination.vue");

// Milisegundos de espera tras la última tecla antes de consultar al servidor.
const ESPERA_BUSQUEDA = 450;
// Letras mínimas para lanzar una búsqueda automática.
const MINIMO_LETRAS = 3;

export default {
    name: "CursosLista",
    components: {Pagination},
    props: {
        // Si es requerido falso, que sea Default Vacio
        getParams: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            permisos: [],
            search: "",
            campo: "todos",
            camposBusqueda: [
                {valor: "todos", texto: "Todos los campos", icono: "manage_search"},
                {valor: "identidad", texto: "Identidad", icono: "badge"},
                {valor: "nombre", texto: "Nombre del participante", icono: "person_search"},
                {valor: "registro", texto: "N.° de registro", icono: "confirmation_number"},
                {valor: "curso", texto: "Curso", icono: "school"},
            ],
            participante: null,
            sugerencias: [],
            cargandoSugerencias: false,
            temporizador: null,
            temporizadorSugerencias: null,
            secuenciaConsulta: 0,
            ultimaBusqueda: {texto: "", campo: "todos"},
            pagination: {},
            pageActual: 1,
            rowsPage: this.$store.state.arrayRowsPages[0],
            loading: false,
            catAnyos: [],
            unidadesOperativas: [],
            cursos: [],
            tableHeaders: [
                {text: 'Identidad', value: 'numero_identidad', align: 'left', sortable: false},
                {text: 'Nombres Participante', value: 'nombres_apellidos', align: 'left', sortable: false},
                {text: 'Registro', value: 'registro', align: 'left', sortable: false},
                {text: 'Curso', value: 'curso', align: 'left', sortable: false},
                {text: 'Período', value: 'fecha_inicio', align: 'left', sortable: false},
                {text: 'Tutor', value: 'tutor', align: 'left', sortable: false},
                {text: 'N.° Import.', value: 'importacion_numero', align: 'left', sortable: false},
                {text: 'Acciones', align: 'center', sortable: false},
            ],
            filtros: {
                aprobado: this.getParams.aprobado,
                anyo: null,
                unidad_operativa_id: null,
                persona_id: null,
            }
        }
    },

    computed: {
        etiquetaCampo() {
            const etiquetas = {
                todos: "Buscar por identidad, registro, nombre o curso",
                identidad: "Número de identidad",
                nombre: "Nombre o apellido del participante",
                registro: "Número de registro",
                curso: "Nombre del curso",
            };
            return etiquetas[this.campo];
        },
        placeholderCampo() {
            const ejemplos = {
                todos: "Escribe al menos 3 caracteres",
                identidad: "Ej. 0801199912345, sin guiones",
                nombre: "Ej. Juan Carlos Mondragón",
                registro: "Ej. 2658171",
                curso: "Ej. Excel intermedio",
            };
            return ejemplos[this.campo];
        },
        hayBusqueda() {
            return !!(this.ultimaBusqueda.texto || this.filtros.persona_id);
        },
        descripcionBusqueda() {
            if (this.participante) {
                return `de ${this.participante.nombre} ${this.participante.apellido}`;
            }
            const campo = this.camposBusqueda.find(c => c.valor === this.ultimaBusqueda.campo);
            return `con "${this.ultimaBusqueda.texto}" en ${campo ? campo.texto.toLowerCase() : 'los campos'}`;
        },
        chips() {
            const chips = [];
            if (this.participante) {
                chips.push({
                    clave: "participante", icono: "person", titulo: "Participante",
                    valor: `${this.participante.nombre} ${this.participante.apellido} (${this.participante.numero_identidad})`,
                });
            } else if (this.ultimaBusqueda.texto) {
                const campo = this.camposBusqueda.find(c => c.valor === this.ultimaBusqueda.campo);
                chips.push({
                    clave: "texto", icono: campo ? campo.icono : "search", titulo: campo ? campo.texto : "Texto",
                    valor: this.ultimaBusqueda.texto,
                });
            }
            if (this.filtros.anyo) {
                chips.push({clave: "anyo", icono: "event", titulo: "Año", valor: this.filtros.anyo});
            }
            if (this.filtros.unidad_operativa_id) {
                const unidad = this.unidadesOperativas.find(u => u.unidad_operativa_id === this.filtros.unidad_operativa_id);
                chips.push({clave: "unidad", icono: "account_balance", titulo: "Unidad", valor: unidad ? unidad.unidad_operativa : this.filtros.unidad_operativa_id});
            }
            return chips;
        },
        // Palabras a resaltar en la tabla, normalizadas como en el servidor.
        palabrasResaltar() {
            if (!this.ultimaBusqueda.texto) return [];
            return this.normalizar(this.ultimaBusqueda.texto).split(/\s+/).filter(p => p.length >= 2);
        },
    },

    watch: {
        // Búsqueda automática mientras se escribe.
        search(texto) {
            clearTimeout(this.temporizador);
            clearTimeout(this.temporizadorSugerencias);

            const limpio = (texto || "").trim();

            if (this.campo === "nombre" && limpio.length >= MINIMO_LETRAS && !this.participante) {
                this.temporizadorSugerencias = setTimeout(() => this.cargarSugerencias(limpio), 300);
            }

            if (limpio.length >= MINIMO_LETRAS || limpio.length === 0) {
                this.temporizador = setTimeout(() => {
                    if (this.participante) return; // con participante elegido manda el filtro exacto
                    if (limpio !== this.ultimaBusqueda.texto) this.cursosBuscar();
                }, ESPERA_BUSQUEDA);
            }
        },
    },

    methods: {
        cursosNuevo() {
            this.$router.push({name: 'CursosNuevo'});
        },
        cursosGetFiltros() {
            window.axios.get('/cursos/get_filtros', {}).then(async response => {
                if (response.data.success) {
                    this.catAnyos = response.data.data.catAnyos;
                    this.unidadesOperativas = response.data.data.unidadesOperativas;
                    // Despues de asignar los filtros, vamos a traer los datos
                    await this.cursosGet();
                } else if (response.data.success === false) {
                    this.$toast.error(response.data.message);
                }
            })
                .catch(error => {
                    console.log(error)
                    this.$toast.error("No se pudo listar datos.");
                });
        },
        cursosBuscar() {
            clearTimeout(this.temporizador);
            this.pageActual = 1;
            this.cursosGet();
        },
        cursosGet() {
            this.loading = true;
            const texto = this.participante ? "" : (this.search || "").trim();
            this.ultimaBusqueda = {texto, campo: this.campo};

            let params = {
                filtros: this.filtros,
                busqueda: texto,
                campo: this.campo,
                page: this.pageActual,
                rowsPage: this.rowsPage,
            };

            // Cada consulta lleva un número; si llega una respuesta de una
            // consulta anterior (más lenta), se descarta para no pisar la actual.
            const secuencia = ++this.secuenciaConsulta;

            window.axios.get('/cursos', {params}).then(response => {
                if (secuencia !== this.secuenciaConsulta) return;
                if (response.data.success) {
                    let data = response.data.data;
                    this.cursos = data.cursos.data;
                    this.pagination = data.pagination;
                } else if (response.data.success === false) {
                    this.$toast.error(response.data.message);
                }
            })
                .catch(error => {
                    if (secuencia !== this.secuenciaConsulta) return;
                    console.log(error)
                    this.$toast.error("No se pudo listar datos.");
                })
                .finally(() => {
                    if (secuencia === this.secuenciaConsulta) this.loading = false;
                })
        },
        cargarSugerencias(texto) {
            this.cargandoSugerencias = true;
            const params = {busqueda: texto, campo: "nombre", cat_tipo_persona_id: 3};
            window.axios.get('/personas/search', {params}).then(response => {
                if (response.data.success) {
                    this.sugerencias = response.data.data.map(p => ({
                        ...p,
                        etiqueta: `${p.nombre} ${p.apellido} · ${p.numero_identidad}`,
                        iniciales: `${(p.nombre || " ")[0]}${(p.apellido || " ")[0]}`.toUpperCase(),
                    }));
                }
            })
                .catch(() => {})
                .finally(() => {
                    this.cargandoSugerencias = false;
                });
        },
        seleccionarParticipante(persona) {
            this.filtros.persona_id = persona ? persona.persona_id : null;
            if (persona) {
                this.search = "";
            }
            this.cursosBuscar();
        },
        cambiarCampo() {
            // Al cambiar el campo se parte de cero para no mezclar criterios.
            this.participante = null;
            this.filtros.persona_id = null;
            this.sugerencias = [];
            const habiaTexto = !!(this.search || "").trim();
            this.search = "";
            this.$nextTick(() => {
                const buscador = this.$refs.buscador;
                if (buscador && buscador.focus) buscador.focus();
            });
            if (habiaTexto) this.cursosBuscar();
        },
        limpiarTexto() {
            this.search = "";
            this.participante = null;
            this.filtros.persona_id = null;
            this.cursosBuscar();
        },
        quitarChip(clave) {
            if (clave === "participante" || clave === "texto") {
                this.limpiarTexto();
                return;
            }
            if (clave === "anyo") this.filtros.anyo = null;
            if (clave === "unidad") this.filtros.unidad_operativa_id = null;
            this.cursosBuscar();
        },
        limpiarTodo() {
            this.search = "";
            this.participante = null;
            this.filtros.persona_id = null;
            this.filtros.anyo = null;
            this.filtros.unidad_operativa_id = null;
            this.campo = "todos";
            this.cursosBuscar();
        },
        normalizar(texto) {
            return (texto || "").toString().toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "");
        },
        escapar(texto) {
            return (texto || "").toString()
                .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
        },
        // Resalta lo buscado en la celda cuando el campo corresponde (o cuando se busca en todos).
        resaltar(valor, columna) {
            const texto = this.escapar(valor);
            const campo = this.ultimaBusqueda.campo;
            const aplica = campo === "todos" || campo === columna;
            if (!aplica || !this.palabrasResaltar.length || this.participante) return texto;

            // Se compara sin tildes pero se devuelve el texto original.
            const plano = this.normalizar(texto);
            let resultado = "";
            let i = 0;
            while (i < texto.length) {
                let coincidencia = 0;
                for (const palabra of this.palabrasResaltar) {
                    if (plano.startsWith(palabra, i) && palabra.length > coincidencia) coincidencia = palabra.length;
                }
                if (coincidencia) {
                    resultado += `<mark class="resaltado">${texto.substr(i, coincidencia)}</mark>`;
                    i += coincidencia;
                } else {
                    resultado += texto[i];
                    i++;
                }
            }
            return resultado;
        },
        cursoEdit(curso) {
            if (typeof curso == "object") {
                let token = window.btoa(curso.curso_id);
                this.$router.push({name: 'CursosEditar', query: {token}});
            } else {
                this.$toast.error("Parametro no valido.");
            }
        },
        setCambiarPagina(data) {
            this.pageActual = data.page;
            this.rowsPage = data.rowsPage;
            this.cursosGet();
        },
    },
    created() {
        Auth.checkPermisos(this.$route.path).then((res) => {
            this.permisos = res;

            if (!this.permisos[2]) {
                this.regresar();
            }

            this.cursosGetFiltros();
        });
    }
}
</script>

<style>
.tabla-cursos mark.resaltado {
    background: #F6E3BF;
    color: #1B2340;
    border-radius: 3px;
    padding: 0 2px;
}
</style>
